import { IconBrandWhatsapp, IconMail, IconPhone } from "@tabler/icons-react";
import type { PublicBrand } from "../api";
import { useSession } from "../session";

export const waLink = (number: string) => `https://wa.me/${number.replace(/[^\d]/g, "")}`;
export const telLink = (number: string) => `tel:${number.replace(/[^\d+]/g, "")}`;

export function BrandChannels({ brand, compact = false }: { brand: PublicBrand; compact?: boolean }) {
  const { t } = useSession();
  return (
    <div className={`channels ${compact ? "channels-compact" : ""}`}>
      <a href={`mailto:${brand.channels.email}`} rel="external">
        <IconMail size={18} stroke={1.75} />
        <span>{compact ? t("write") : brand.channels.email}</span>
      </a>
      <a href={waLink(brand.channels.whatsapp)} target="_blank" rel="external noreferrer">
        <IconBrandWhatsapp size={18} stroke={1.75} />
        <span>{compact ? t("whatsapp") : brand.channels.whatsapp}</span>
      </a>
      <a href={telLink(brand.channels.phone)} rel="external">
        <IconPhone size={18} stroke={1.75} />
        <span>{compact ? t("call") : brand.channels.phone}</span>
      </a>
    </div>
  );
}

export function Footer() {
  const { brand, lang, t } = useSession();
  if (!brand) return null;
  const statement = brand.groupStatement[lang] ?? brand.groupStatement.en ?? "";
  return (
    <footer className="footer">
      <p className="footer-statement">{statement}</p>
      <BrandChannels brand={brand} />
      <p className="footer-legal">
        {t("operatedBy", { entity: brand.legalEntity })} · <a href="/privacy">{t("privacy")}</a>
      </p>
    </footer>
  );
}
